import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home/block4-人工智能商城.png")